<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de Paciente">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

import List from '@/components/atencao-basica/marcador-consumo-alimentar/List'

export default {
    components: { List }
}
</script>